import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { CorporateTirage } from '../model/tirage/corporate-tirage';
import { UpdateCorporateTirage } from '../model/tirage/update-corporate-tirage';
import { CreateCorporateTirage } from '../model/tirage/create-corporate-tirage';

@Injectable({
    providedIn: 'root'
  })
  export class CorporateTirageService{
  
    constructor(private _restClientService : RestClientService) 
    {}

    findAllByFacilite(faciliteId) 
    {
        return this._restClientService.load<CorporateTirage[]>('corporate-tirage/find-all-by-facilite?faciliteId='+faciliteId);
    }
    
    findById(id) 
    {
        return this._restClientService.load<CorporateTirage>('corporate-tirage/find-by-id/'+id);
    }
    
    update(update: UpdateCorporateTirage ) 
    {
        return  this._restClientService.put<UpdateCorporateTirage>('corporate-tirage/update', update);
    }
    
    add(create: CreateCorporateTirage ) 
    {
        return  this._restClientService.save<CreateCorporateTirage>('corporate-tirage/add', create);
    }
    
    delete(id) {
      return this._restClientService.delete<any>('corporate-tirage/delete/'+id);
    }

  


}      

    